import { useGetAccountStatesQueryOptions } from "@/api/account-state/account-state"
import { useGetCustomerQueryOptions } from "@/api/customer/customer"
import { SmartChargingState } from "@/api/model"
import { MyAccountRoute } from "@/constants/routes/myAccount"
import ErrorReporter from "@/services/ErrorReporter"
import { useQueryClient } from "@tanstack/vue-query"
import { NavigationGuard } from "vue-router"

export const smartChargingGuard: NavigationGuard = async () => {
  const queryClient = useQueryClient()

  try {
    const accountId = (
      await queryClient.ensureQueryData(useGetCustomerQueryOptions())
    ).accountIDLastVisited

    if (!accountId) throw new Error("accountId not found")

    const { smartCharging } = await queryClient.ensureQueryData(
      useGetAccountStatesQueryOptions(accountId),
    )

    if (smartCharging === SmartChargingState.notEnrolled) {
      return { path: MyAccountRoute.home }
    }
  } catch (error) {
    console.error("smartChargingGuard: ", error)
    ErrorReporter.report(error)
    return { path: MyAccountRoute.home }
  }
}
